export enum RequestType {
	Deposit = 1,
	Withdrawal = 2,
	Send = 3,
	Exchange = 4,
	Point = 5,
	Voucher = 6,
	PeerToPeer = 7,
	CryptoWithdrawalRequest = 8,
	ProfileForgotPassword = 35,
	EnableGoogleAuthenticator = 14,
	RemoveGoogleAuthenticator = 15,
}

export enum RequestTypeNew {
	Deposit = 'Deposit',
	Withdrawal = 'Withdrawal',
	Send = 'Send',
	Exchange = 'Exchange',
	Point = 'Point',
	Voucher = 'Voucher',
	PeerToPeer = 'PeerToPeer',
	CryptoWithdrawalRequest = 'CryptoWithdrawalRequest',
	ProfileForgotPassword = 'ProfileForgotPassword',
	EnableGoogleAuthenticator = 'EnableGoogleAuthenticator',
	RemoveGoogleAuthenticator = 'RemoveGoogleAuthenticator'
}
